import React from "react";
import "../../assets/css/Home/banner.css";

const MainBanner = ({BannerImage}) => {
    return (
        <img src={BannerImage} alt="banner" />
    );
}

export default MainBanner;